import React, { useEffect, useState } from 'react';
import { ScrollView, View } from 'react-native';
import GolfWidget from './GolfWidget';
import Colors from '../../constants/Colorsv2';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { LeagueProps, TournamentProps } from '../../store/types/sr_svc';
import { event_getMatchesByTournamentId, event_getTournamentByTournamentId, event_getTournamentByTournamentIdNoStore } from '../../store/actionsv1/events';
import TournamentHolder from '../../Componentsv1/TournamentHolder';
import { market_getLatestTradesByEventId } from '../../store/actionsv1/markets';


const TournamentScreen = ({ route, navigation } : any) => {
    const [ tournament, setTournament ] = useState<TournamentProps | undefined>(undefined);
    const dispatch = useDispatch();
    const app_size:{width:number} = useSelector((state:any) => state.util.app_size, (left, right) => left.width == right.width)
    const league:LeagueProps = useSelector((state:any) => state.event.leagues.find(l => l.league_id == route.params.league_id), (left, right) => left?.league_id == right?.league_id);
    const stored_tournament = useSelector((state:any) => state.event.tournaments[route.params.tournament_id], (left, right) => left?.tournament_id == right?.tournament_id);
    useEffect(() => {
        if(!route.params.tournament_id){ return }
        getTournamentData(route.params.tournament_id);
    },[route.params.tournament_id])

    const getTournamentData = async(id:string) => {
        dispatch(market_getLatestTradesByEventId(id, 'tournament'));
        await dispatch(event_getMatchesByTournamentId(id))
        if(stored_tournament){ return setTournament(stored_tournament) }
        await dispatch(event_getTournamentByTournamentId(id));
        const tourney = await event_getTournamentByTournamentIdNoStore(id);
        setTournament(tourney)
    }

    if(!league){ return <></> }
    return  (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            {tournament ?
            <Helmet>
                <title>{tournament.tournament_name} Betting Markets</title>
                <meta name='description' content={`BettorEdge betting markets for ${tournament.tournament_name}`} />
                <meta name='og:image' content={league.league_image} />
            </Helmet>
            :<></>}
            <ScrollView style={{ flex:1 }}>
                <View nativeID='tournament_widget' >
                    {league.league_name == 'PGA' ?
                    <View style={{ padding:10, alignItems:'center'  }}>
                        <GolfWidget 
                            width={app_size.width}
                            tournament_id={route.params.tournament_id}
                        />
                    </View>
                    : 
                    <View>
                        <TournamentHolder
                            tournament_id={route.params.tournament_id}
                            navigation={navigation}
                            market_selector_location='top_right'
                            hide_liquidity
                            wrap_markets                            
                        />
                    </View>
                    }
                </View>
            </ScrollView>
        </View>
    )
}

export default TournamentScreen